import { ExtendableError } from './ExtendableError';

export class ApiResponseError extends ExtendableError {
  public status: number;

  public response: Response;

  public data: string | unknown;

  constructor(message: string | unknown, response: Response) {
    const errorMessage =
      typeof message === 'string' ? message : 'There was an error with this API call';
    super(errorMessage);

    this.status = response.status;
    this.response = response;
    this.data = message;
  }
}
